export const homePlannerDragClasses = {
  'planner-column-body': true,
  'lane-header': true,
  'date-month': true,
  'date-number': true,
  'date-abbrev': true
};
